/* eslint-disable camelcase */
import { graphql, useStaticQuery } from "gatsby";

// todo: more reliable filter strategy to exclude myDIRTT resources
// allStoryblokEntry(filter: { full_slug: { regex: "/projects/(.*)/" } }) {
const usePages = () => {
  // ---------------------------------------------------------------------------
  // static data

  const { allStoryblokEntry } = useStaticQuery(graphql`
    {
      allStoryblokEntry {
        edges {
          node {
            id
            uuid

            name
            path
            position
            slug
            lang
            group_id
            full_slug
            content
          }
        }
      }
    }
  `);

  // ---------------------------------------------------------------------------
  // variables

  const data = !allStoryblokEntry?.edges?.[0]
    ? []
    : allStoryblokEntry.edges.map(({ node }) => ({
        ...node,
        content: JSON.parse(node.content)
      }));

  // ---------------------------------------------------------------------------
  // api

  return {
    data
  };
};

export default usePages;
